import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({
  spacing
}) => ({
  root: {
    position: 'absolute',
    right: spacing(2),
    top: '50%',
    marginTop: spacing(-1.5)
  }
}));
